// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1RgWN","approved":"Status_approved__OU2yv","rejected":"Status_rejected__31Cfz","expired":"Status_expired__5yssn","label":"Status_label__2a-bH"};